import { midas } from '@resurs/midas'
import PropTypes from 'prop-types'
import React from 'react'

const _disableUserSelect = {
  userSelect: 'none',
}

const Description = ({ heading, text, children }) => (
  <>
    <label style={_disableUserSelect} className={midas.formLabel}>
      {heading}
    </label>
    <p
      style={{
        paddingTop: '0.3rem',
        marginTop: '0',
        marginBottom: '1rem',
        color: '#a7a9ac',
        ..._disableUserSelect,
      }}
    >
      {text}
    </p>
    {children}
  </>
)

Description.propTypes = {
  heading: PropTypes.string.isRequired,
  text: PropTypes.string.isRequired,
  children: PropTypes.node,
}

Description.defaultProps = {
  children: null,
}

export default Description
